import { mix, observable, pipe, watch } from "@chorda/core";
import { createPreactRenderer } from "@chorda/preact";
const renderer = createPreactRenderer();
export const withPreact = (props) => {
    return mix({
        defaults: {
            preactRoot: () => observable(null),
            $renderer: () => renderer,
        },
        injections: {
            parentEl: $ => $.$context.$dom,
            $pipe: $ => pipe($.$patcher, $.$renderer),
        },
        events: {
            afterInit: (html, { preactRoot }) => {
                preactRoot.$value = html;
            }
        },
        joints: {
            connectToContextDom: ({ preactRoot, parentEl, $renderer }) => {
                watch(() => {
                    if (parentEl.$value) {
                        console.log('preact attach');
                        $renderer.attach(parentEl.$value, preactRoot.$value);
                    }
                    else {
                        console.log('preact detach');
                        $renderer.detach(preactRoot.$value);
                    }
                }, [parentEl]);
            }
        },
    }, props);
};
